import { createContext } from 'react';

/** List of { menuLabel, permission, id } for role-route mapping. Provided by DashboardLayout. */
export const PermissionGatedRoutesContext = createContext([]);

export const PERMISSION_GATED_ROUTES_DEFAULT = [];
